import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { logout } from "../actions/adminActions";
import { getEntries } from "../actions/entryActions";
import { GET_ENTRIES_RESET } from "../constants/entryConstants";
import Header from "../components/Header";
import Table from "../components/Table";
import Loader from "../components/Loader";

const Entries = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminLogin = useSelector((state) => state.adminLogin);
  const { adminInfo } = adminLogin;

  useEffect(() => {
    if (!adminInfo) {
      dispatch(logout(navigate));
    }
  }, [adminInfo]);

  useEffect(() => {
    dispatch(getEntries(page));
  }, [page]);

  const getEntriesInfo = useSelector((state) => state.getEntriesInfo);
  const { loadingGetEntries, getEntriesData, errorGetEntries } = getEntriesInfo;

  useEffect(() => {
    dispatch({ type: GET_ENTRIES_RESET });
    if (getEntriesData) {
      setData(getEntriesData.data);
      setTotal(getEntriesData.total);
      setPage(+getEntriesData.page);
      setLoading(false);
    } else if (errorGetEntries) {
      toast.error(errorGetEntries);
      setLoading(false);
    }
  }, [getEntriesData, errorGetEntries]);

  const columns = [
    {
      field: "invite",
      headerName: "Mobile",
      valueGetter: ({ value }) => (value ? value.mobile : "N/A"),
      minWidth: 200,
    },
    {
      field: "location",
      headerName: "Location",
      valueGetter: ({ value }) => (value ? value.name : "N/A"),
      minWidth: 200,
    },
    {
      field: "user",
      headerName: "User",
      valueGetter: ({ value }) => (value ? value.username : "N/A"),
      minWidth: 200,
    },
    {
      field: "time",
      headerName: "Time",
      valueGetter: ({ value }) =>
        value && moment(value).format("DD-MM-YYYY HH:mm:ss"),
      minWidth: 200,
    },
    {
      field: "cardNumber",
      headerName: "Card Number",
      minWidth: 200,
      valueGetter: ({ value }) => (value ? value : "N/A"),
    },
  ];

  return (
    <Box m="20px">
      <Header title="ENTRIES" subtitle="List of entries" />
      {loading ? (
        <Loader />
      ) : (
        <Table
          onPageChange={(newPage) => {
            setPage(newPage + 1);
          }}
          total={total}
          rows={data}
          columns={columns}
          page={page}
          getRowId={(row) => row._id}
        />
      )}
    </Box>
  );
};

export default Entries;
